import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { CostFormGeneratorService } from "./cost-form-generator.service";
import { CostFormGetterService } from "./cost-form-getter.service";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    providers: [
        CostFormGeneratorService,
        CostFormGetterService
    ],
})
export class CostFormGeneratorModule {
}
